const CalendlyHook = {
  mounted() {
    let currentEl = this.el;
    let lv = this;
    // Set up handlers to listen for Calendly Embed messages
    window.addEventListener("message", function (e) {
      if (isCalendlyEvent(e)) {
        lv.pushEventTo(
          currentEl.getAttribute("phx-target"),
          e.data.event,
          e.data.payload,
        );
      }
    });

    Calendly.initInlineWidget({
      url: this.el.getAttribute("calendly-url"),
      parentElement: this.el,
      prefill: {},
      utm: {},
    });
  },
};

function isCalendlyEvent(e) {
  return (
    e.origin === "https://calendly.com" &&
    e.data.event &&
    e.data.event.indexOf("calendly.") === 0
  );
}

export default CalendlyHook;
